"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeDistrict = void 0;
var React = require("react");
var classnames_1 = require("classnames");
exports.placeDistrict = function (props) {
    if (!props.districtInfo.length)
        return null;
    var isTextIncluded = function (text, pattern, flag) {
        var re = new RegExp(pattern, flag);
        if (re.exec(text))
            return true;
        return false;
    };
    var renderDistrictInfoKey = function (props) {
        var renderDistrictInfo = function (it, i) {
            var changeDistrictInfo = function () { return props.changeDistrictInfo(i); };
            var miniClass = classnames_1.default([
                'c-minitab__item',
                {
                    'c-minitab__item--active': props.currentDistrictInfo === i,
                },
            ]);
            var bodyTitle = (props.t[it.key] ? props.t[it.key] : it.key);
            var displayHTML = isTextIncluded(bodyTitle, '</h[1-6]>', 'i');
            if (displayHTML) {
                return (React.createElement("a", { key: i, className: miniClass, onClick: changeDistrictInfo },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: bodyTitle } })));
            }
            else {
                return (React.createElement("a", { key: i, className: miniClass, onClick: changeDistrictInfo },
                    React.createElement("h3", null, bodyTitle)));
            }
        };
        return (React.createElement("div", { className: "c-minitab" }, props.districtInfo.map(renderDistrictInfo)));
    };
    var renderDistrictInfoValue = function (props) {
        var points = props.districtInfo[props.currentDistrictInfo].value;
        if (points[0].startsWith('<')) {
            return React.createElement("div", { dangerouslySetInnerHTML: { __html: points.join("\n") } });
        }
        return points.map(function (it, i) { return (React.createElement("p", { key: i }, it)); });
    };
    var districtLink = props.districtUrl ? props.districtUrl : '#';
    return (React.createElement("div", { className: "l-pad--4 l-pad-top--2 t--darker" },
        React.createElement("div", { className: "l-container l-container--r48 l-container--stackable" },
            React.createElement("div", { className: "l-container__side" },
                React.createElement("h2", { className: "o-h1 o-h1--serif u-capfirst l-pad" },
                    props.districtPage ? (React.createElement("a", { href: districtLink }, props.district)) : props.district,
                    " - ",
                    React.createElement("br", null),
                    props.t.information)),
            React.createElement("div", { className: "l-container__main" },
                React.createElement("div", { className: "c-district__summary-tabs" }, renderDistrictInfoKey(props)),
                React.createElement("div", { className: "c-district__summary-text" }, renderDistrictInfoValue(props))))));
};
